import { getEquipmentSessionObservations } from '../../api/api';
import { EquipmentSessionId, NormalizedEquipmentSession } from '../sessions';
import { AssetObservationsState, createAssetObservationsSlice } from './abstract/asset';

const equipmentSessionObservationsSlice = createAssetObservationsSlice<NormalizedEquipmentSession>(
  'equipmentsSessions',
  {
    fetchObservations: getEquipmentSessionObservations,
  },
);

const { fetchAssetObservations } = equipmentSessionObservationsSlice.actions;
export { fetchAssetObservations as fetchEquipmentSessionObservations };

export const { selectState: selectEquipmentSessionObservationsState } = equipmentSessionObservationsSlice.getSelectors(
  (state: { observations: { equipmentsSessions: AssetObservationsState<{ id: EquipmentSessionId }> } }) =>
    state.observations.equipmentsSessions,
);

export default equipmentSessionObservationsSlice.reducer;
